import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CalendarView from '../CalendarView';
import RoomSelection from '../RoomSelection';
import BookedCandidatesList from './BookedCandidatesList';

export default function InterviewsManager({ initialTab = 'calendar' }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(urlTab || initialTab);

  useEffect(() => {
    if (urlTab && ['booked-candidates', 'calendar', 'create', 'rooms'].includes(urlTab)) {
      setActiveTab(urlTab);
    }
  }, [urlTab]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setSearchParams({ tab: tabId });
  };

  const tabs = [
    { id: 'booked-candidates', label: '📋 Booked Candidates' },
    { id: 'calendar', label: '📅 Calendar & Schedule' },
    { id: 'create', label: '➕ Create Interview Room' },
    { id: 'rooms', label: '🚪 Active Rooms' }
  ];

  return (
    <div style={styles.container}>
      {/* Header Tabs */}
      <div style={styles.tabsHeader}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            style={{
              ...styles.tabBtn,
              ...(activeTab === tab.id ? styles.activeTabBtn : {})
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div style={styles.tabContent}>
        {activeTab === 'booked-candidates' && <BookedCandidatesList />}
        {activeTab === 'calendar' && (
          <CalendarView
            hideNavbar={true}
            onNavigateToRooms={() => handleTabChange('rooms')}
          />
        )}
        {activeTab === 'create' && <RoomSelection hideNavbar={true} defaultStep="calendar" />}
        {activeTab === 'rooms' && <RoomSelection hideNavbar={true} defaultStep="main" />}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    textAlign: 'left'
  },
  tabsHeader: {
    display: 'flex',
    gap: '8px',
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '12px',
    flexShrink: 0
  },
  tabBtn: {
    padding: '8px 16px',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: '#f1f5f9',
    color: '#64748b',
    fontSize: '13.5px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.15s ease'
  },
  activeTabBtn: {
    backgroundColor: '#2563eb',
    color: '#ffffff'
  },
  tabContent: {
    flex: 1
  }
};
